import { Box, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { Button, Link } from 'evee-ui-common/components/base';
import { Region } from 'evee-ui-common/enums';
import { formatPriceNumber, getHomeUrl } from 'evee-ui-common/utils';
import useRegion from 'store/modules/app/hooks/useRegion';
import useListYourCar from 'store/modules/listYourCar/hooks/useListYourCar';

import styles from './styles';

const HostListYourCar = ({ classes }) => {
  const [onListYourCar] = useListYourCar();
  const { region, currency } = useRegion();

  const titleJsx = (
    <>
      Ready to rent out
      <br />
      your electric car?
    </>
  );

  const subtitleJsx = (
    <>
      Earn up to {formatPriceNumber(2000)} {currency.id}/month by sharing your car with others
    </>
  );

  const nzTitleJsx = (
    <>
      Save up to $500
      <br />
      in commission fees
    </>
  );

  const nzSubtitleJsx = (
    <Box color="white">
      New Hosts in New Zealand will have their first $500 in evee commission fees waived, for a
      limited time.{' '}
      <Link color="inherit" href={`${getHomeUrl(region)}/terms`}>
        Find out more{' '}
      </Link>
    </Box>
  );

  return (
    <Box className={classes.container}>
      <Box className={classes.leftColumn}>
        <Typography paragraph className={classes.title}>
          {region.id === Region.newZealand.id ? nzTitleJsx : titleJsx}
        </Typography>

        <Typography paragraph className={classes.subtitle}>
          {region.id === Region.newZealand.id ? nzSubtitleJsx : subtitleJsx}
        </Typography>

        <Button
          text="Start earning"
          size="large"
          style={{ width: '156px' }}
          onClick={onListYourCar}
        />
      </Box>
    </Box>
  );
};

HostListYourCar.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    leftColumn: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
  }).isRequired,
};

HostListYourCar.defaultProps = {};

export default withStyles(styles)(HostListYourCar);
